const FILE_STATUS = {
    initialized: 0,
    waiting: 1,
    processing: 2,
    failed: -1,
    processed: 3,
};

export { FILE_STATUS }